import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
// import { convertToRaw } from "draft-js";
// import draftToHtml from "draftjs-to-html";
import _ from "lodash";
import validate from "validate.js";
import classNames from "classnames";
import HttpClient from "services/HttpClient";
import Input from "blocks/Input";
import Select from "blocks/Select";
import {
  PROVIDER_CONSTRAINS,
  TARGET_FILE_MAX_SIZE,
  PROVIDER_LOGO_CONTENT_TYPES
} from "constants/provider_constrains";
import NoAvaBig from "styles/img/Placeholder user.svg";
import ProviderWorkshops from "./providerWorkshops";
// import TextEditor from "./TextEditor";
import QuillEditor from 'components/create_workshop/QuillEditor';

import {
  GET_PROVIDER_WORKSHOPS,
  DELETE_PROVIDER,
  CREATE_PROVIDER,
  UPDATE_PROVIDER,
  GET_PROVIDER
} from "constants/backend_routes";
import { PROVIDER_ROLES } from "constants/provider_roles";

let options = PROVIDER_ROLES;

@withRouter
@inject("providerStore")
@inject("alert")
@observer
export default class CreateProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      all_workshops: [],
      errors: {},
      formData: this.props.providerStore.setInitialState()
    };
  }

  componentWillMount() {
    this.initialState(this.props.location);
    this.listener = this.props.history.listen(() => {
      this.initialState();
    });
  }

  initialState = () => {
    if (this.props.match.params.id) {
      let id = this.props.match.params.id;

      new HttpClient().get(GET_PROVIDER_WORKSHOPS).then(response => {
        this.setState({
          ...this.state,
          all_workshops: this.getProvidersWorkshopsFromBackUrl(
            response.body.workshops
          )
        });
      });

      new HttpClient().get(GET_PROVIDER + id).then(response => {
        this.props.providerStore.updateProvider(response.body.provider);
        let curentFormData = this.parseProvidersWorkshops(
          this.props.providerStore.provider
        );
        this.setState({
          ...this.state,
          formData: curentFormData
        });
      });
    } else {
      new HttpClient().get(GET_PROVIDER_WORKSHOPS).then(response => {
        this.setState({
          ...this.state,
          all_workshops: this.getProvidersWorkshopsFromBackUrl(
            response.body.workshops
          )
        });
      });
    }
  };

  parseProvidersWorkshops = provided_workshops => {
    let parsedArray = JSON.parse(
      JSON.stringify(this.props.providerStore.provider.provided_workshops)
    ).map(el => {
      return {
        id: JSON.parse(el.id),
        value: el.title,
        label: el.title,
        workshop_type: el.workshop_type || null
      };
    });
    return _.assign({}, provided_workshops, {
      provided_workshops: parsedArray
    });
  };

  getProvidersWorkshopsFromBackUrl = data => {
    return data.map(el => {
      let newObj = {
        id: el.id,
        value: el.label,
        label: el.label,
        workshop_type: el.workshop_type
      };
      return newObj;
    });
  };

  componentWillUnmount() {
    this.listener();
  }

  handleChange = data => {
    let newFormData = _.assign({}, this.state.formData, data);
    this.setState({ formData: newFormData });
  };

  handleLogoChange = e => {
    const event = e;
    if (e.target.files && e.target.files[0]) {
      let file = e.target.files[0];
      if (
        file.size > TARGET_FILE_MAX_SIZE ||
        !PROVIDER_LOGO_CONTENT_TYPES.includes(file.type)
      ) {
        let newState = _.assign({}, this.state, { file_errors: true });
        this.setState(newState);
        return;
      }
      let reader = new FileReader();

      reader.onload = e => {
        let newState = _.assign({}, this.state.formData, {
          profile_logo: file,
          profile_logo_url: e.target.result
        });
        this.setState({ formData: newState });
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  getUserAvatar = () => {
    if (this.state.formData.profile_logo_url)
      return (
        <img
          className="provider-avatar"
          src={this.state.formData.profile_logo_url}
        />
      );
    return <img src={NoAvaBig} className="no-ava" alt="avatar" />;
  };

  handleDelete = () => {
    new HttpClient()
      .delete(`${DELETE_PROVIDER}${this.props.match.params.id}`)
      .then(response => {});
    this.props.history.push("/provider_bios");
  };

  handleSubmit = () => {
    let errors =
      validate(this.state.formData, PROVIDER_CONSTRAINS, { message: false }) ||
      false;

    if (!_.isEmpty(errors)) {
      this.setState({ errors: errors });
    } else {
      this.setState({ errors: {} });
      console.warn(
        "THIS.PROPS.PROVIDERSTORE.PROVIDER.provided_workshops",
        this.props.providerStore.provider.provided_workshops
      );
      let mappedProvidersWorkshops = this.props.providerStore.provider.provided_workshops.map(
        el => {
          return {
            id: el.id,
            label: el.title || el.label,
            workshop_type: el.workshop_type
          };
        }
      );

      console.warn("mappedProvidersWorkshops", mappedProvidersWorkshops);

      let providersData = _.assign({}, this.state.formData, {
        provided_workshops: mappedProvidersWorkshops
      });

      let form = new FormData();
      let data = _.assign({}, providersData);

      if (data.bio && data.qualifications) {
        // _.assign(data, {
        //   bio: draftToHtml(convertToRaw(data.bio.getCurrentContent())),
        //   qualifications: draftToHtml(
        //     convertToRaw(data.qualifications.getCurrentContent())
        //   )
        // });
        if (data.bio.trim() === "<p></p>") {
          data.bio = null;
        }
        if (data.qualifications.trim() === "<p></p>") {
          data.qualifications = null;
        }
      }

      Object.keys(data).forEach(key => {
        if (key != "provided_workshops") {
          form.append(`provider[${key}]`, data[key]);
        } else if (key == "profile_logo") {
          form.append(`provider[profile_logo]`, data[key]);
          form.delete(`provider[profile_logo_url]`);
        } else if (key == "profile_logo_url") {
          form.delete(`provider[profile_logo_url]`);
        }
      });

      (data.provided_workshops || []).forEach(workshop => {
        form.append(`provider[provided_workshops[]][id]`, workshop.id);
        form.append(`provider[provided_workshops[]][title]`, workshop.label);
        form.append(
          `provider[provided_workshops[]][workshop_type]`,
          workshop.workshop_type
        );
      });

      if (this.props.match.params.id) {
        new HttpClient()
          .multipart(UPDATE_PROVIDER + this.props.match.params.id, form, "PUT")
          .then(resposne => {
            this.props.alert.success("Provider successfully updated");
          });
      } else {
        new HttpClient()
          .multipart(CREATE_PROVIDER, form, "POST")
          .then(response => {
            this.props.history.push("/provider_bios");
          });
      }
    }
  };

  handleChangeWorkshops = data => {
    console.warn(
      "data.provided_workshops FROM handleChangeWorkshops",
      data.provided_workshops
    );
    this.props.providerStore.setProvidedWorkshops(data.provided_workshops);

    let providedWorkshops = _.assign({}, this.state.formData, data);
    console.warn("providedWorkshops", providedWorkshops);

    this.setState({
      formData: providedWorkshops
    });
  };

  handleRemoveProvidedWorkshop = id => {
    this.props.providerStore.deleteCurrentProvidedWorkshop(id);

    let newData = this.state.formData.provided_workshops.filter(
      el => el.label !== id
    );
    let newProvidedWorkshops = _.assign({}, this.state.formData, {
      provided_workshops: newData
    });
    console.warn("newProvidedWorkshops", newProvidedWorkshops);
    this.setState({
      formData: newProvidedWorkshops
    });
  };

  render() {
    return (
      <main className="main-content">
        <div className="container-fluid">
          {window.innerWidth > 767 ? (
            <div className="row provider-creator">
              <div className="col-md-9 right-part">
                <div className="row">
                  <div className="col-md-3">
                    <div className="user-profile-avatar-holder">
                      <div className="user-profile-avatar">
                        {this.getUserAvatar()}
                      </div>
                      <div className="user-profile-name-holder">
                        <label htmlFor="myProfileAvatar">
                          {this.state.formData.profile_logo_url ? (
                            <span className="user-profile-change">change</span>
                          ) : (
                            <span className="user-profile-change">
                              add PHOTO
                            </span>
                          )}
                        </label>
                        <input
                          id="myProfileAvatar"
                          onChange={this.handleLogoChange}
                          type="file"
                          name=""
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col">
                        <Select
                          elements={options}
                          placeholder="Select role"
                          label="Role"
                          name="user_type"
                          // value={this.getUserType()}
                          value={this.state.formData.user_type}
                          errors={this.state.errors.user_type}
                          handleChange={this.handleChange}
                        />
                      </div>
                    </div>
                    <div
                      className={classNames("row", {
                        "error-block": this.state.errors.name
                      })}
                    >
                      <div className="col">
                        <Input
                          name="name"
                          type="text"
                          value={this.state.formData.name}
                          handleChange={this.handleChange}
                          placeholder="Provider Name"
                          error={this.state.errors.name}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className={classNames({
                      "col-12": true,
                      "has-error": this.state.errors.bio
                    })}
                  >
                    <div className="content-block">
                      <h4 className="title">Biography</h4>

                        <QuillEditor
                          showToolbar={true}
                          onChange={(value) => this.handleChange({bio: value})}
                          value={this.state.formData.bio}
                          placeholder={'Description editor...'}
                        />

                      {/* <TextEditor
                        description={this.state.formData.bio}
                        name="bio"
                        onChange={this.handleChange}
                        type="workshop"
                      /> */}

                      {/*<span className="text-editor-counter">{newCaption.length}/5000</span>*/}
                      <span className="error-text" style={{ color: "#e91e63" }}>
                        {this.state.errors.bio}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div
                    className={classNames({
                      "col-12": true,
                      "has-error": this.state.errors.qualifications
                    })}
                  >
                    <div className="content-block">
                      <h4 className="title">Qualifications/Experience</h4>

                        <QuillEditor
                          showToolbar={true}
                          onChange={(value) => this.handleChange({qualifications: value})}
                          value={this.state.formData.qualifications}
                          placeholder={'Description editor...'}
                        />

                      {/* <TextEditor
                        description={this.state.formData.qualifications}
                        name="qualifications"
                        onChange={this.handleChange}
                        type="workshop"
                      /> */}

                      {/*<span className="text-editor-counter">{newCaption.length}/5000</span>*/}
                      <span className="error-text" style={{ color: "#e91e63" }}>
                        {this.state.errors.qualifications}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 contact-block purchased">
                <h4 className="title">Contact Information</h4>
                <div className="input-wrapper">
                  <div
                    className={classNames("row", {
                      "error-block": this.state.errors.email
                    })}
                  >
                    <div className="col">
                      <Input
                        name="email"
                        type="text"
                        value={this.state.formData.email}
                        handleChange={this.handleChange}
                        placeholder="Email"
                        error={this.state.errors.email}
                      />
                    </div>
                  </div>
                  <div
                    className={classNames("row", {
                      "error-block": this.state.errors.phone
                    })}
                  >
                    <div className="col">
                      <Input
                        name="phone"
                        type="text"
                        value={this.state.formData.phone}
                        handleChange={this.handleChange}
                        placeholder="Phone Number"
                        error={this.state.errors.phone}
                      />
                    </div>
                  </div>
                  <div
                    className={classNames("row", {
                      "error-block": this.state.errors.website
                    })}
                  >
                    <div className="col">
                      <Input
                        name="website"
                        type="text"
                        value={this.state.formData.website}
                        handleChange={this.handleChange}
                        placeholder="Website (Optional)"
                        error={this.state.errors.website}
                      />
                    </div>
                  </div>
                  <div
                    className={classNames("row", {
                      "error-block": this.state.errors.linkedin_link
                    })}
                  >
                    <div className="col">
                      <Input
                        name="linkedin_link"
                        type="text"
                        social={true}
                        required={true}
                        value={this.state.formData.linkedin_link}
                        handleChange={this.handleChange}
                        placeholder="Linkedin (Optional)"
                        error={this.state.errors.linkedin_link}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                        </svg>
                      </Input>
                    </div>
                  </div>
                  <div
                    className={classNames("row", {
                      "error-block": this.state.errors.facebook_link
                    })}
                  >
                    <div className="col">
                      <Input
                        name="facebook_link"
                        type="text"
                        social={true}
                        required={true}
                        value={this.state.formData.facebook_link}
                        handleChange={this.handleChange}
                        placeholder="Facebook (Optional)"
                        error={this.state.errors.facebook_link}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
                        </svg>
                      </Input>
                    </div>
                  </div>
                  <div
                    className={classNames("row", {
                      "error-block": this.state.errors.twitter_link
                    })}
                  >
                    <div className="col">
                      <Input
                        name="twitter_link"
                        type="text"
                        social={true}
                        required={true}
                        value={this.state.formData.twitter_link}
                        handleChange={this.handleChange}
                        placeholder="Twitter (Optional)"
                        error={this.state.errors.twitter_link}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m12.71 6.33c.48-.4 1.04-.88 1.29-1.41-.41.21-.9.34-1.44.41.5-.36.91-.83 1.12-1.47-.52.28-1.05.52-1.71.64-1.55-1.87-5.26-.35-4.6 2.45-2.61-.16-4.2-1.34-5.52-2.79-.75 1.22-.1 3.07.79 3.58-.46-.03-.81-.17-1.14-.33.04 1.54.89 2.28 2.08 2.68-.36.07-.76.09-1.14.03.37 1.07 1.14 1.74 2.46 1.88-.9.76-2.56 1.29-3.9 1.08 1.15.73 2.46 1.31 4.28 1.23 4.41-.2 7.36-3.36 7.43-7.98z" />
                        </svg>
                      </Input>
                    </div>
                  </div>
                </div>
                <ProviderWorkshops
                  elements={this.state.all_workshops}
                  placeholder="Workshop Title"
                  name="provided_workshops"
                  value={this.state.formData.provided_workshops}
                  handleRemoveValue={this.handleRemoveProvidedWorkshop}
                  errors={this.state.errors.provided_workshops}
                  handleChange={this.handleChangeWorkshops}
                />
                <div className="btn-wrapper">
                  {!this.props.match.params.id ? (
                    <button className="btn publish" onClick={this.handleSubmit}>
                      Publish provider bio
                    </button>
                  ) : (
                    <div className="edit-btn-wrap">
                      <button className="btn edit" onClick={this.handleSubmit}>
                        Save
                      </button>
                      <button
                        className="btn delete"
                        onClick={this.handleDelete}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="only-web-wrapper">
              <div className="img-block">
                <svg xmlns="http://www.w3.org/2000/svg" width="120" height="89">
                  <path
                    fill="#039EE5"
                    fillRule="evenodd"
                    d="M118.5 88.779H1.5c-.828 0-1.5-.673-1.5-1.505 0-.831.672-1.505 1.5-1.505h117c.828 0 1.5.674 1.5 1.505 0 .832-.672 1.505-1.5 1.505zM87.209 71.653l-1.277.739v5.325c0 2.997-2.429 5.433-5.415 5.433H39.483c-2.986 0-5.415-2.436-5.415-5.433v-3.586l-2.027-1.174c-4.032-2.337-5.42-7.531-3.092-11.577l1.978-3.441c.784-1.385 1.808-3.172 3.141-4.167V51.79a5.424 5.424 0 0 1 5.327-5.424c2.742-3.676 7.1-4.333 10.809-4.39 1.374-1.491 2.256-3.18 2.604-4.966l-1.478-.898a8.299 8.299 0 0 1-3.954-6.495l-.12-1.704c-.26.248-.595.41-.966.424a1.487 1.487 0 0 1-1.379-.788 19.062 19.062 0 0 1-2.268-9.019c0-6.473 3.22-12.995 8.012-16.23 2.72-1.837 7.198-3.511 13.162-1.183 11.94.181 15.106 11.374 15.106 17.316 0 4.14-1.399 8.005-3.938 10.886a1.5 1.5 0 0 1-1.607.426 1.494 1.494 0 0 1-.725-.541l-.029.412a8.297 8.297 0 0 1-3.955 6.496l-1.477.898c.348 1.787 1.23 3.475 2.605 4.967 3.764.065 8.085.738 10.808 4.389a5.424 5.424 0 0 1 5.327 5.424v4.051c.834 1.005 1.56 2.366 2.097 3.299l1.722 2.993c1.918 3.333.78 7.595-2.542 9.52zM34.067 58.504c-.206.345-.387.667-.531.921l-1.989 3.46c-1.501 2.609-.606 5.958 1.994 7.464l.526.305v-12.15zM50.054 44.99c-2.704.072-4.713.504-6.216 1.367h8.067l-1.851-1.367zm16.605-1.31l.359-.265c-1.2-1.452-2.061-3.054-2.552-4.747l-1.642.999a5.435 5.435 0 0 1-2.824.794 5.43 5.43 0 0 1-2.823-.794l-1.643-.999c-.491 1.693-1.352 3.295-2.552 4.747l1.316.971 2.671 1.971h6.062l3.628-2.677zm6.288-23.503c.022.031.028.068.048.1.791 1.134 1.435 2.415 1.769 3.851.758-1.73 1.159-3.668 1.159-5.695 0-.143-.142-14.307-12.399-14.307-.194 0-.386-.039-.566-.111-3.86-1.575-7.536-1.305-10.628.782-4 2.7-6.687 8.219-6.687 13.733 0 1.746.286 3.479.837 5.12a11.174 11.174 0 0 1 2.328-2.033 11.911 11.911 0 0 1 1.831-1.015c.004-.001.007-.004.011-.006.525-.25 1.427-.664 2.418-1.043.99-.379 2.069-.724 2.948-.838.12-.013.239-.015.358-.003h.008c1.223.076 7.179-.482 7.41-2.973.016-.172.068-.333.137-.484.022-.049.053-.09.08-.135a1.419 1.419 0 0 1 .595-.564c.054-.027.103-.057.16-.078.023-.009.041-.025.065-.032a.887.887 0 0 1 .234-.033c.061-.01.115-.037.178-.039h.008c.101 0 .309.057.594.167.816.259 1.898.876 3.006 1.68 1.132.788 2.35 1.824 3.409 3.09.251.291.486.581.689.866zm-3.316 9.226l.557-7.883-.111-.141c-.26-.32-.532-.624-.813-.908-.055-.055-.109-.112-.164-.166-.3-.292-.605-.562-.909-.813-.044-.036-.087-.075-.13-.11a16.64 16.64 0 0 0-.968-.724l-.047-.034c-.333-.23-.65-.432-.936-.604a5.345 5.345 0 0 1-1.182 1.334c-.111.091-.245.159-.363.243-2.018 1.441-4.897 1.915-6.745 2.053-.658.055-1.185.068-1.507.066-.17.026-.383.086-.587.139-.129.033-.239.05-.379.093-.203.061-.427.144-.644.221-.167.058-.325.106-.497.172-.216.082-.432.174-.649.263-.177.073-.357.142-.531.217a31.523 31.523 0 0 0-1.165.528h.001l-.001.001a8.995 8.995 0 0 0-1.566.892c-.097.069-.182.149-.276.22l.35 4.942a5.28 5.28 0 0 0 2.516 4.133l5.846 3.555a2.434 2.434 0 0 0 2.538 0l5.845-3.555a5.28 5.28 0 0 0 2.517-4.134zm.317 15.586l-1.853 1.368h8.072c-1.51-.87-3.523-1.302-6.219-1.368zm12.984 6.801a2.422 2.422 0 0 0-2.415-2.423H39.483a2.422 2.422 0 0 0-2.415 2.423v25.927a2.422 2.422 0 0 0 2.415 2.424h41.034a2.422 2.422 0 0 0 2.415-2.424V51.79zM60 72.478c-3.418 0-6.198-2.79-6.198-6.219 0-3.43 2.78-6.219 6.198-6.219 3.418 0 6.198 2.789 6.198 6.219 0 3.429-2.78 6.219-6.198 6.219zm0-9.428a3.207 3.207 0 0 0-3.198 3.209A3.206 3.206 0 0 0 60 69.468a3.206 3.206 0 0 0 3.198-3.209A3.207 3.207 0 0 0 60 63.05zm3.422-34.282l-.095.003a1.502 1.502 0 0 1-1.496-1.411 1.502 1.502 0 0 1 1.403-1.596l3.132-.197a1.504 1.504 0 0 1 .188 3.004l-3.132.197zm-6.749.003l-.095-.003-3.132-.197a1.503 1.503 0 0 1-1.403-1.596 1.498 1.498 0 0 1 1.591-1.408l3.132.197a1.502 1.502 0 0 1 1.403 1.596 1.502 1.502 0 0 1-1.496 1.411z"
                  />
                </svg>
                <p>Is available only for web version</p>
              </div>
            </div>
          )}
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/create_provider/CreateProvider.jsx